// extracted by mini-css-extract-plugin
export default {"header":"Table_header__wAvbW","link":"Table_link__uWT4Q","active":"Table_active__J6GAp","inactive":"Table_inactive__hwGSt"};